namespace Nobox {

    @Serenity.Decorators.registerFormatter()
    export class LinkFormatter implements Slick.Formatter {
        format(ctx: Slick.FormatterContext) {
            if (ctx.value == "" || ctx.value == null) {
                return "";
            } else {
                return `<a title="open link in new tab" target="_blank" style="cursor:pointer;" href="${ctx.value}">${ctx.value}`;
            }
        }
    }
}